import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ConfigService } from '../../../../config/config.service';
import { CapturaPeso } from '../../../../types/CapturaPeso.type';

export interface CapturarPesoResponse {
  remessa: number;
  numero_pesagem: number;
  peso: number;
  tara: number;
  tipo_produto: string;
}

export interface ConfirmarPesagemDto {
  remessa: number;
  peso: number;
  analise_ativa?: boolean;
  numero_lacre?: string | null;
  analises?: { codigo_analise: string; valor_analise: number | null }[] | null;
}

export interface RemessaPesagemDto {
  remessa: number;
  produto: string;
  cliente: string;
  etapa: string;
  tipo_produto: string;
  permite_digitacao_manual: boolean;
}

export interface PageResponse<T> {
  content: T[];
  page: number;
  size: number;
  totalElements: number;
  totalPages: number;
}

export interface CapturaPesoFiltro {
  remessas?: number[];
  produtos?: string[];
  placas?: string[];
  dataInicio?: string;
  dataFim?: string;
  dtPeso1Inicio?: string;
  dtPeso1Fim?: string;
  dtPeso2Inicio?: string;
  dtPeso2Fim?: string;
  statusRemessa?: string[];
  statusInteg?: string[];
  busca?: string;
}

export interface CapturaPesoResumo {
  remessas: number[];
  produtos: string[];
  placas: string[];
  statusRemessa: string[];
  statusInteg: string[];
  contadoresStatus: Record<string, number>;
}

@Injectable({
  providedIn: 'root'
})
export class CapturaPesoService {

  constructor(private httpClient: HttpClient, private configService: ConfigService) { }

  buscarPaginado(instancia: string, page: number, size: number, sort: string, filtro: CapturaPesoFiltro): Observable<PageResponse<CapturaPeso>> {
    const params: any = this.montarParams(instancia, filtro);
    params['page'] = page;
    params['size'] = size;
    params['sort'] = sort;
    return this.httpClient.get<PageResponse<CapturaPeso>>(`${this.configService.getApiUrlRoot()}/pesagem-balanca`, { params });
  }

  buscarResumo(instancia: string, filtro: CapturaPesoFiltro): Observable<CapturaPesoResumo> {
    const params = this.montarParams(instancia, filtro);
    return this.httpClient.get<CapturaPesoResumo>(`${this.configService.getApiUrlRoot()}/pesagem-balanca/resumo`, { params });
  }

  private montarParams(instancia: string, filtro: CapturaPesoFiltro): any {
    const params: any = { instancia };
    if (filtro.remessas?.length) params['remessas'] = filtro.remessas;
    if (filtro.produtos?.length) params['produtos'] = filtro.produtos;
    if (filtro.placas?.length) params['placas'] = filtro.placas;
    if (filtro.dataInicio) params['dataInicio'] = filtro.dataInicio;
    if (filtro.dataFim) params['dataFim'] = filtro.dataFim;
    if (filtro.dtPeso1Inicio) params['dtPeso1Inicio'] = filtro.dtPeso1Inicio;
    if (filtro.dtPeso1Fim) params['dtPeso1Fim'] = filtro.dtPeso1Fim;
    if (filtro.dtPeso2Inicio) params['dtPeso2Inicio'] = filtro.dtPeso2Inicio;
    if (filtro.dtPeso2Fim) params['dtPeso2Fim'] = filtro.dtPeso2Fim;
    if (filtro.statusRemessa?.length) params['statusRemessa'] = filtro.statusRemessa;
    if (filtro.statusInteg?.length) params['statusInteg'] = filtro.statusInteg;
    if (filtro.busca) params['busca'] = filtro.busca;
    return params;
  }

  exportar(instancia: string, dataInicio?: string, dataFim?: string) {
    let params: any = { instancia };
    if (dataInicio) params['dataInicio'] = dataInicio;
    if (dataFim) params['dataFim'] = dataFim;
    return this.httpClient.get(`${this.configService.getApiUrlRoot()}/pesagem-balanca/relatorios/exportar`, { params, responseType: 'blob' });
  }

  capturarPesoRemessa(remessa: number): Observable<CapturarPesoResponse> {
    return this.httpClient.post<CapturarPesoResponse>(
      `${this.configService.getApiUrlRoot()}/pesagem-balanca/capturar-peso/${remessa}`, {}
    );
  }

  confirmarPesagem(remessa: number, dto: ConfirmarPesagemDto): Observable<any> {
    return this.httpClient.post(
      `${this.configService.getApiUrlRoot()}/pesagem-balanca/${remessa}/confirmar`, dto
    );
  }

  buscarDadosPesagem(remessa: number): Observable<RemessaPesagemDto> {
    return this.httpClient.get<RemessaPesagemDto>(
      `${this.configService.getApiUrlRoot()}/pesagem-balanca/${remessa}/pesar`
    );
  }
}
